import { shiftModalRoutingService } from 'modals/ShiftModal/ShiftModal.ui.context';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useURLParameters } from 'hooks';
import { createContext, FC, useContext, useEffect, useMemo } from 'react';
import { useFetchAgencyTeamMembersDataContext } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/FetchAgencyTeamMembers.data.context';

interface ISendToAgencyTeamMemberViewProps {
  goToSummaryView: () => void;
}

export const SendToAgencyTeamMemberViewPropsContext =
  createContext<ISendToAgencyTeamMemberViewProps>({} as ISendToAgencyTeamMemberViewProps);

export const SendToAgencyTeamMemberViewPropsProvider: FC = ({ children }) => {
  const { error } = useFetchAgencyTeamMembersDataContext();
  const { data } = useShiftModalDataContext();
  const order = data?.order;
  const [, { removeParam }] = useURLParameters();

  useEffect(() => {
    switch (error?.message) {
      case 'order cannot be assigned':
        shiftModalRoutingService.goToView('ShiftUnavailableView');
        break;
    }
  }, [error?.message]);

  useEffect(() => {
    if (!order.canAssign && !order.canB2bAssign) removeParam('shiftModalActiveModalView');
  }, [order.canAssign, order.canB2bAssign, removeParam]);

  const contextValue = useMemo(
    () => ({
      goToSummaryView: () =>
        shiftModalRoutingService.goToView('AssignToAgencyTeamMemberSummaryView'),
    }),
    [],
  );

  return (
    <SendToAgencyTeamMemberViewPropsContext.Provider value={contextValue}>
      {children}
    </SendToAgencyTeamMemberViewPropsContext.Provider>
  );
};

export const useSendToAgencyTeamMemberViewPropsContext = (): ISendToAgencyTeamMemberViewProps =>
  useContext(SendToAgencyTeamMemberViewPropsContext);
